export default "__VITE_ASSET__56a56650__"